import React from 'react';

// 水果图标组件
export function FruitIcon() {
  return (
    <img 
      src={require('../assets/images/Fruit.png')} 
      alt="Fruits" 
      style={{width: '56px', height: '66px', objectFit: 'contain'}} 
    />
  );
}

// 海鲜(螃蟹)图标组件
export function SeafoodIcon() {
  return (
    <img 
      src={require('../assets/images/Crab.png')} 
      alt="Seafood" 
      style={{width: '56px', height: '66px', objectFit: 'contain'}} 
    />
  );
}

// 肉类图标组件
export function MeatIcon() {
  return (
    <img 
      src={require('../assets/images/Meat.png')} 
      alt="Meat" 
      style={{width: '56px', height: '66px', objectFit: 'contain'}} 
    />
  );
}

// 甜点图标组件
export function DessertIcon() {
  return (
    <img 
      src={require('../assets/images/Dessert.png')} 
      alt="Dessert" 
      style={{width: '56px', height: '66px', objectFit: 'contain'}} 
    />
  );
}

// Plus 图标组件
export function PlusIcon({ size = 20 }) {
  return (
    <div className="relative w-full h-full">
      <div className="absolute" style={{ inset: '20.833%' }}>
        <div className="absolute" style={{ inset: '-8.571%' }}>
          <svg className="block w-full h-full" fill="none" viewBox="0 0 14 14">
            <path
              d="M6.83333 1V12.6667M1 6.83333H12.6667"
              stroke="var(--color-text-invert)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

// 搜索图标
export function SearchIcon() {
  return (
    <svg className="block w-full h-full" fill="none" viewBox="0 0 17 17">
      <path
        d="M16 16L12.375 12.375M14.3333 7.66667C14.3333 11.3486 11.3486 14.3333 7.66667 14.3333C3.98477 14.3333 1 11.3486 1 7.66667C1 3.98477 3.98477 1 7.66667 1C11.3486 1 14.3333 3.98477 14.3333 7.66667Z"
        stroke="var(--color-text-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

// 购物袋图标
export function ShoppingBagIcon() {
  return (
    <svg className="block w-full h-full" fill="none" viewBox="0 0 24 24">
      <path
        d="M3 6L6 2H18L21 6M3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6M3 6H21M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
        stroke="var(--color-text-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

// 首页图标
export function HomeIcon() {
  return (
    <svg className="block w-full h-full" fill="none" viewBox="0 0 17 19">
      <path
        d="M6 17.6667V9.33333H11V17.6667M1 6.83333L8.5 1L16 6.83333V16C16 16.442 15.8244 16.866 15.5118 17.1785C15.1993 17.4911 14.7754 17.6667 14.3333 17.6667H2.66667C2.22464 17.6667 1.80072 17.4911 1.48816 17.1785C1.17559 16.866 1 16.442 1 16V6.83333Z"
        stroke="var(--color-brand-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

// 苹果图标
export function AppleIcon() {
  return (
    <svg className="block w-full h-full" fill="none" viewBox="0 0 16 20">
      <path
        d="M11.2739 1.51122C9.88877 1.27608 8.77702 1.6177 8 2.54649"
        stroke="var(--color-icon-soft)"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M13.2617 6.17115C11.3508 4.47358 9.28063 6.17115 8.00671 6.17115C6.73278 6.17115 4.64919 4.47359 2.73828 6.17116C0.349634 8.29313 0.827363 11.7209 1.78282 14.1693C2.73828 16.6177 4.33071 18.25 5.28616 18.25C6.05053 18.25 7.36975 17.5971 8.00671 17.5971C8.64366 17.5971 9.94947 18.25 10.7138 18.25C11.6693 18.25 13.2617 16.6177 14.2172 14.1693C15.1726 11.7209 15.6504 8.29312 13.2617 6.17115Z"
        stroke="var(--color-icon-soft)"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}

// 更多图标
export function MoreIcon() {
  return (
    <svg className="block w-full h-full" fill="none" viewBox="0 0 16 4">
      <path
        d="M7.66667 2.66667C8.1269 2.66667 8.5 2.29357 8.5 1.83333C8.5 1.3731 8.1269 1 7.66667 1C7.20643 1 6.83333 1.3731 6.83333 1.83333C6.83333 2.29357 7.20643 2.66667 7.66667 2.66667Z"
        stroke="var(--color-icon-soft)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M13.5 2.66667C13.9602 2.66667 14.3333 2.29357 14.3333 1.83333C14.3333 1.3731 13.9602 1 13.5 1C13.0398 1 12.6667 1.3731 12.6667 1.83333C12.6667 2.29357 13.0398 2.66667 13.5 2.66667Z"
        stroke="var(--color-icon-soft)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M1.83333 2.66667C2.29357 2.66667 2.66667 2.29357 2.66667 1.83333C2.66667 1.3731 2.29357 1 1.83333 1C1.3731 1 1 1.3731 1 1.83333C1 2.29357 1.3731 2.66667 1.83333 2.66667Z"
        stroke="var(--color-icon-soft)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

// 特价图标
export function SpecialIcon() {
  return (
    <div 
      className="flex items-center justify-center h-full w-full"
      style={{ transform: 'rotate(321.69deg)' }}
    >
      <svg className="block" fill="none" viewBox="0 0 12 19" style={{ width: '10px', height: '17px' }}>
        <path
          d="M1 7.19873C1 6.95988 1.08549 6.72891 1.24101 6.54763L5.24101 1.88477C5.64008 1.41957 6.35992 1.41957 6.75899 1.88477L10.759 6.54763C10.9145 6.72891 11 6.95987 11 7.19872V17C11 17.5523 10.5523 18 10 18H2C1.44772 18 1 17.5523 1 17V7.19873Z"
          stroke="var(--color-icon-soft)"
          strokeWidth="2"
        />
        <circle
          cx="6"
          cy="7"
          fill="var(--color-icon-soft)"
          r="1"
        />
      </svg>
    </div>
  );
} 